// // import React from "react";
// // import { Doughnut } from "react-chartjs-2";

// // // ─── Mock Pie Data keyed by [financialYear][ulbType][ulbName] ───────────────
// // const pieChartData = {
// //   "2025-26 (Running)": {
// //     "All ULBs": {
// //       "All ULBs": { revenue: 5600, expenses: 4200 },
// //     },
// //     "Nagar Nigam": {
// //       "All ULBs": { revenue: 3400, expenses: 2700 },
// //       Lucknow:    { revenue: 840,  expenses: 630  },
// //       Jhansi:     { revenue: 410,  expenses: 310  },
// //       Ghaziabad:  { revenue: 680,  expenses: 510  },
// //       Bareilly:   { revenue: 375,  expenses: 280  },
// //       Ayodhya:    { revenue: 262,  expenses: 195  },
// //       Varanasi:   { revenue: 625,  expenses: 458  },
// //       Kanpur:     { revenue: 735,  expenses: 538  },
// //     },
// //     "Nagar Palika": {
// //       "All ULBs": { revenue: 1340, expenses: 1020 },
// //       Barabanki:  { revenue: 188,  expenses: 139  },
// //       Raebareli:  { revenue: 171,  expenses: 126  },
// //     },
// //     "Nagar Panchayat": {
// //       "All ULBs": { revenue: 560, expenses: 425 },
// //     },
// //   },
// //   "2024-25": {
// //     "All ULBs": {
// //       "All ULBs": { revenue: 4900, expenses: 3700 },
// //     },
// //     "Nagar Nigam": {
// //       "All ULBs": { revenue: 3000, expenses: 2250 },
// //       Lucknow:    { revenue: 780,  expenses: 575  },
// //       Jhansi:     { revenue: 378,  expenses: 278  },
// //       Ghaziabad:  { revenue: 672,  expenses: 492  },
// //       Bareilly:   { revenue: 350,  expenses: 257  },
// //       Ayodhya:    { revenue: 245,  expenses: 180  },
// //       Varanasi:   { revenue: 613,  expenses: 449  },
// //       Kanpur:     { revenue: 727,  expenses: 532  },
// //     },
// //     "Nagar Palika": {
// //       "All ULBs": { revenue: 1198, expenses: 881 },
// //       Barabanki:  { revenue: 177,  expenses: 130 },
// //       Raebareli:  { revenue: 162,  expenses: 119 },
// //     },
// //     "Nagar Panchayat": {
// //       "All ULBs": { revenue: 513, expenses: 378 },
// //     },
// //   },
// //   "2023-24": {
// //     "All ULBs": {
// //       "All ULBs": { revenue: 4250, expenses: 3150 },
// //     },
// //     "Nagar Nigam": {
// //       "All ULBs": { revenue: 2520, expenses: 1872 },
// //       Lucknow:    { revenue: 660,  expenses: 485  },
// //       Jhansi:     { revenue: 321,  expenses: 236  },
// //       Ghaziabad:  { revenue: 575,  expenses: 422  },
// //       Bareilly:   { revenue: 298,  expenses: 219  },
// //       Ayodhya:    { revenue: 209,  expenses: 154  },
// //       Varanasi:   { revenue: 523,  expenses: 384  },
// //       Kanpur:     { revenue: 620,  expenses: 455  },
// //     },
// //     "Nagar Palika": {
// //       "All ULBs": { revenue: 1021, expenses: 749 },
// //       Barabanki:  { revenue: 152,  expenses: 111 },
// //       Raebareli:  { revenue: 138,  expenses: 101 },
// //     },
// //     "Nagar Panchayat": {
// //       "All ULBs": { revenue: 436, expenses: 321 },
// //     },
// //   },
// // };

// // const getPieData = (filters) => {
// //   const { financialYear, ulbType, ulbName } = filters;
// //   const yearData  = pieChartData[financialYear]  || pieChartData["2025-26 (Running)"];
// //   const typeData  = yearData[ulbType]             || yearData["All ULBs"];
// //   const nameData  = typeData[ulbName]             || typeData["All ULBs"];
// //   return nameData;
// // };

// // // ─── Component ───────────────────────────────────────────────────────────────
// // const PieChart = ({ appliedFilters }) => {
// //   const { revenue, expenses } = getPieData(appliedFilters);

// //   const data = {
// //     labels: ["Revenue", "Expenses"],
// //     datasets: [
// //       {
// //         data: [revenue, expenses],
// //         backgroundColor: ["#4CAF50", "#FF5722"],
// //         borderWidth: 1,
// //       },
// //     ],
// //   };

// //   const options = {
// //     responsive: true,
// //     maintainAspectRatio: false,
// //     plugins: {
// //       legend: {
// //         position: "bottom",
// //         labels: {
// //           boxWidth: 12,
// //           padding: 15,
// //         },
// //       },
// //       tooltip: {
// //         callbacks: {
// //           label: (ctx) => ` ₹${ctx.parsed.toLocaleString("en-IN")} Cr`,
// //         },
// //       },
// //     },
// //     cutout: "65%",
// //   };

// //   return (
// //     <div style={{ height: "300px", width: "300px", margin: "0 auto" }}>
// //       <Doughnut data={data} options={options} />
// //     </div>
// //   );
// // };

// // export default PieChart;



// import React from "react";
// import { Doughnut } from "react-chartjs-2";

// const pieChartData = {
//   "2025-26 (Running)": {
//     "All ULBs": {
//       "All ULBs": { revenue: 5600, expenses: 4200 },
//     },
//     "Nagar Nigam": {
//       "All ULBs": { revenue: 3400, expenses: 2700 },
//       Lucknow:    { revenue: 840,  expenses: 630  },
//       Jhansi:     { revenue: 410,  expenses: 310  },
//       Ghaziabad:  { revenue: 680,  expenses: 510  },
//       Bareilly:   { revenue: 375,  expenses: 280  },
//       Ayodhya:    { revenue: 262,  expenses: 195  },
//       Varanasi:   { revenue: 625,  expenses: 458  },
//       Kanpur:     { revenue: 735,  expenses: 538  },
//     },
//     "Nagar Palika": {
//       "All ULBs": { revenue: 1340, expenses: 1020 },
//       Barabanki:  { revenue: 188,  expenses: 139  },
//       Raebareli:  { revenue: 171,  expenses: 126  },
//     },
//     "Nagar Panchayat": {
//       "All ULBs": { revenue: 560, expenses: 425 },
//     },
//   },
//   "2024-25": {
//     "All ULBs": {
//       "All ULBs": { revenue: 4900, expenses: 3700 },
//     },
//     "Nagar Nigam": {
//       "All ULBs": { revenue: 3000, expenses: 2250 },
//       Lucknow:    { revenue: 780,  expenses: 575  },
//       Jhansi:     { revenue: 378,  expenses: 278  },
//       Ghaziabad:  { revenue: 672,  expenses: 492  },
//       Bareilly:   { revenue: 350,  expenses: 257  },
//       Ayodhya:    { revenue: 245,  expenses: 180  },
//       Varanasi:   { revenue: 613,  expenses: 449  },
//       Kanpur:     { revenue: 727,  expenses: 532  },
//     },
//     "Nagar Palika": {
//       "All ULBs": { revenue: 1198, expenses: 881 },
//       Barabanki:  { revenue: 177,  expenses: 130 },
//       Raebareli:  { revenue: 162,  expenses: 119 },
//     },
//     "Nagar Panchayat": {
//       "All ULBs": { revenue: 513, expenses: 378 },
//     },
//   },
//   "2023-24": {
//     "All ULBs": {
//       "All ULBs": { revenue: 4250, expenses: 3150 },
//     },
//     "Nagar Nigam": {
//       "All ULBs": { revenue: 2520, expenses: 1872 },
//       Lucknow:    { revenue: 660,  expenses: 900  },
//       Jhansi:     { revenue: 321,  expenses: 236  },
//       Ghaziabad:  { revenue: 575,  expenses: 422  },
//       Bareilly:   { revenue: 298,  expenses: 219  },
//       Ayodhya:    { revenue: 209,  expenses: 154  },
//       Varanasi:   { revenue: 523,  expenses: 384  },
//       Kanpur:     { revenue: 620,  expenses: 455  },
//     },
//     "Nagar Palika": {
//       "All ULBs": { revenue: 1021, expenses: 749 },
//       Barabanki:  { revenue: 152,  expenses: 111 },
//       Raebareli:  { revenue: 138,  expenses: 101 },
//     },
//     "Nagar Panchayat": {
//       "All ULBs": { revenue: 436, expenses: 321 },
//     },
//   },
// };

// const getPieData = (filters) => {
//   const { financialYear, ulbType, ulbName } = filters;
//   const yearData  = pieChartData[financialYear]  || pieChartData["2025-26 (Running)"];
//   const typeData  = yearData[ulbType]             || yearData["All ULBs"];
//   const nameData  = typeData[ulbName]             || typeData["All ULBs"];
//   return nameData;
// };

// // ─── Component ───────────────────────────────────────────────────────────────
// const PieChart = ({ appliedFilters }) => {
//   const { revenue, expenses } = getPieData(appliedFilters);

//   const data = {
//     labels: ["Revenue", "Expenses"],
//     datasets: [
//       {
//         data: [revenue, expenses],
//         backgroundColor: ["#16A085", "#FF5722"],
//         borderWidth: 1,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: "bottom",
//         labels: {
//           boxWidth: 12,
//           padding: 15,
//         },
//       },
//       tooltip: {
//         callbacks: {
//           label: (ctx) => ` ₹${ctx.parsed.toLocaleString("en-IN")} Cr`,
//         },
//       },
//     },
//     cutout: "45%",
//   };

//   const chartKey = `${appliedFilters.financialYear}-${appliedFilters.ulbType}-${appliedFilters.ulbName}`;

//   return (
//     <div style={{ height: "300px", width: "300px", margin: "0 auto", marginTop:"50px" }}>
//       <Doughnut key={chartKey} data={data} options={options} />
//     </div>
//   );
// };

// export default PieChart;


import React, { useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { connect } from "react-redux";

const PieChart = (props) => {
 const { revenueTrend } = props;
  const trend = revenueTrend && revenueTrend.revenueSummary;

  const data = {
    labels: ["Revenue", "Expenses"],
     datasets: [
    {
      data: trend
        ? [trend.revenue, trend.expenses]
        : [0, 0],
      backgroundColor: ["#16A085", "#FF5722"],
      borderWidth: 1,
    },
  ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 12,
          padding: 15,
        },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => ` ₹${ctx.parsed.toLocaleString("en-IN")} Cr`,
        },
      },
    },
    cutout: "45%",
  };

  // const chartKey = `${appliedFilters.financialYear}-${appliedFilters.ulbType}-${appliedFilters.ulbName}`;

  return (
    <div style={{ height: "300px", width: "300px", margin: "0 auto", marginTop:"50px" }}>
      <Doughnut 
       key=""
       data={data} options={options} />
    </div>
  );
};

export default PieChart;


// WEBPACK FOOTER //
// src/modules/employee/Home/PieChart.js